import { ExtensionCompletionConditionRuler } from "@edp-pmf/bpmn-model";


export class MultiInstanceLoopCharacteristics {
    static Clr_Type_ID = 'wf.MultiInstanceLoopCharacteristics';

    readonly ClrTypeID: string = MultiInstanceLoopCharacteristics.Clr_Type_ID;

    enable: boolean;
    sequential: boolean;
    loopCardinality: string;
    completionCondition: string;
    completionConditionRules: Array<ExtensionCompletionConditionRuler>;

    constructor() {
        this.enable = false;
        this.sequential = false;
        this.loopCardinality = null;
        this.completionCondition = null;
        this.completionConditionRules = new Array<ExtensionCompletionConditionRuler>();
    }
}